export const organizationSettingsConstants = {
  GET_ORGANIZATION_INFO_REQUEST: 'ORGANIZATIONSETTINGS/GET_ORGANIZATION_INFO_REQUEST',
  GET_ORGANIZATION_INFO_SUCCESS: 'ORGANIZATIONSETTINGS/GET_ORGANIZATION_INFO_SUCCESS',
  GET_ORGANIZATION_INFO_FAILURE: 'ORGANIZATIONSETTINGS/GET_ORGANIZATION_INFO_FAILURE',

  EDIT_ORGANIZATION_INFO_REQUEST: 'ORGANIZATIONSETTINGS/EDIT_ORGANIZATION_INFO_REQUEST',
  EDIT_ORGANIZATION_INFO_SUCCESS: 'ORGANIZATIONSETTINGS/EDIT_ORGANIZATION_INFO_SUCCESS',
  EDIT_ORGANIZATION_INFO_FAILURE: 'ORGANIZATIONSETTINGS/EDIT_ORGANIZATION_INFO_FAILURE',

  GET_ORGANIZATION_WORKPLACE_LIST_REQUEST: 'ORGANIZATIONSETTINGS/GET_ORGANIZATION_WORKPLACE_LIST_REQUEST',
  GET_ORGANIZATION_WORKPLACE_LIST_SUCCESS: 'ORGANIZATIONSETTINGS/GET_ORGANIZATION_WORKPLACE_LIST_SUCCESS',
  GET_ORGANIZATION_WORKPLACE_LIST_FAILURE: 'ORGANIZATIONSETTINGS/GET_ORGANIZATION_WORKPLACE_LIST_FAILURE',

  GET_LEADERSHIP_TEAM_REQUEST: 'ORGANIZATIONSETTINGS/GET_LEADERSHIP_TEAM_REQUEST',
  GET_LEADERSHIP_TEAM_SUCCESS: 'ORGANIZATIONSETTINGS/GET_LEADERSHIP_TEAM_SUCCESS',
  GET_LEADERSHIP_TEAM_FAILURE: 'ORGANIZATIONSETTINGS/GET_LEADERSHIP_TEAM_FAILURE',

  GET_ORGANIZATION_MEMBERS_REQUEST: 'ORGANIZATIONSETTINGS/GET_ORGANIZATION_MEMBERS_REQUEST',
  GET_ORGANIZATION_MEMBERS_SUCCESS: 'ORGANIZATIONSETTINGS/GET_ORGANIZATION_MEMBERS_SUCCESS',
  GET_ORGANIZATION_MEMBERS_FAILURE: 'ORGANIZATIONSETTINGS/GET_ORGANIZATION_MEMBERS_FAILURE',

  GET_ORGANIZATION_SUBSCRIPTION_REQUEST: 'ORGANIZATIONSETTINGS/GET_ORGANIZATION_SUBSCRIPTION_REQUEST',
  GET_ORGANIZATION_SUBSCRIPTION_SUCCESS: 'ORGANIZATIONSETTINGS/GET_ORGANIZATION_SUBSCRIPTION_SUCCESS',
  GET_ORGANIZATION_SUBSCRIPTION_FAILURE: 'ORGANIZATIONSETTINGS/GET_ORGANIZATION_SUBSCRIPTION_FAILURE',

  GET_PAYMENT_INFORMATION_URL_REQUEST: 'ORGANIZATIONSETTINGS/GET_PAYMENT_INFORMATION_URL_REQUEST',
  GET_PAYMENT_INFORMATION_URL_SUCCESS: 'ORGANIZATIONSETTINGS/GET_PAYMENT_INFORMATION_URL_SUCCESS',
  GET_PAYMENT_INFORMATION_URL_FAILURE: 'ORGANIZATIONSETTINGS/GET_PAYMENT_INFORMATION_URL_FAILURE',

  GET_INVOICES_REQUEST: 'ORGANIZATIONSETTINGS/GET_INVOICES_REQUEST',
  GET_INVOICES_SUCCESS: 'ORGANIZATIONSETTINGS/GET_INVOICES_SUCCESS',
  GET_INVOICES_FAILURE: 'ORGANIZATIONSETTINGS/GET_INVOICES_FAILURE',

  GET_DOWNLOAD_INVOICE_REQUEST: 'ORGANIZATIONSETTINGS/GET_DOWNLOAD_INVOICE_REQUEST',
  GET_DOWNLOAD_INVOICES_SUCCESS: 'ORGANIZATIONSETTINGS/GET_DOWNLOAD_INVOICES_SUCCESS',
  GET_DOWNLOAD_INVOICES_FAILURE: 'ORGANIZATIONSETTINGS/GET_DOWNLOAD_INVOICES_FAILURE',

  DELETE_WORKPLACE_REQUEST: 'ORGANIZATIONSETTINGS/DELETE_WORKPLACE_REQUEST',
  DELETE_WORKPLACE_SUCCESS: 'ORGANIZATIONSETTINGS/DELETE_WORKPLACE_SUCCESS',
  DELETE_WORKPLACE_FAILURE: 'ORGANIZATIONSETTINGS/DELETE_WORKPLACE_FAILURE',

  UPDATE_MEMBER_ROLE_REQUEST: 'ORGANIZATIONSETTINGS/UPDATE_MEMBER_ROLE_REQUEST',
  UPDATE_MEMBER_ROLE_SUCCESS: 'ORGANIZATIONSETTINGS/UPDATE_MEMBER_ROLE_SUCCESS',
  UPDATE_MEMBER_ROLE_FAILURE: 'ORGANIZATIONSETTINGS/UPDATE_MEMBER_ROLE_FAILURE',

  REMOVE_MEMBER_REQUEST: 'ORGANIZATIONSETTINGS/REMOVE_MEMBER_REQUEST',
  REMOVE_MEMBER_SUCCESS: 'ORGANIZATIONSETTINGS/REMOVE_MEMBER_SUCCESS',
  REMOVE_MEMBER_FAILURE: 'ORGANIZATIONSETTINGS/REMOVE_MEMBER_FAILURE',

  REINSTATE_ACCOUNT_REQUEST: 'ORGANIZATIONSETTINGS/REINSTATE_ACCOUNT_REQUEST',
  REINSTATE_ACCOUNT_SUCCESS: 'ORGANIZATIONSETTINGS/REINSTATE_ACCOUNT_SUCCESS',
  REINSTATE_ACCOUNT_FAILURE: 'ORGANIZATIONSETTINGS/REINSTATE_ACCOUNT_FAILURE',

  DELETE_ACCOUNT_REQUEST: 'ORGANIZATIONSETTINGS/DELETE_ACCOUNT_REQUEST',
  DELETE_ACCOUNT_SUCCESS: 'ORGANIZATIONSETTINGS/DELETE_ACCOUNT_SUCCESS',
  DELETE_ACCOUNT_FAILURE: 'ORGANIZATIONSETTINGS/DELETE_ACCOUNT_FAILURE',

  GET_ORG_FILES_REQUEST: 'ORGANIZATIONSETTINGS/GET_ORG_FILES_REQUEST',
  GET_ORG_FILES_SUCCESS: 'ORGANIZATIONSETTINGS/GET_ORG_FILES_SUCCESS',
  GET_ORG_FILES_FAILURE: 'ORGANIZATIONSETTINGS/GET_ORG_FILES_FAILURE',

  ADD_ORG_FILE_REQUEST: 'ORGANIZATIONSETTINGS/ADD_ORG_FILE_REQUEST',
  ADD_ORG_FILE_SUCCESS: 'ORGANIZATIONSETTINGS/ADD_ORG_FILE_SUCCESS',
  ADD_ORG_FILE_FAILURE: 'ORGANIZATIONSETTINGS/ADD_ORG_FILE_FAILURE',

  UPDATE_ORG_FILE_REQUEST: 'ORGANIZATIONSETTINGS/UPDATE_ORG_FILE_REQUEST',
  UPDATE_ORG_FILE_SUCCESS: 'ORGANIZATIONSETTINGS/UPDATE_ORG_FILE_SUCCESS',
  UPDATE_ORG_FILE_FAILURE: 'ORGANIZATIONSETTINGS/UPDATE_ORG_FILE_FAILURE',

  DELETE_ORG_FILE_REQUEST: 'ORGANIZATIONSETTINGS/DELETE_ORG_FILE_REQUEST',
  DELETE_ORG_FILE_SUCCESS: 'ORGANIZATIONSETTINGS/DELETE_ORG_FILE_SUCCESS',
  DELETE_ORG_FILE_FAILURE: 'ORGANIZATIONSETTINGS/DELETE_ORG_FILE_FAILURE',

  CLEAR_FLAGS_ORG_DOCS: 'ORGANIZATIONSETTINGS/CLEAR_FLAGS_ORG_DOCS',

  UPDATE_ORG_ROLE_REQUEST: 'ORGANIZATION/UPDATE_ORG_ROLE_REQUEST',
  UPDATE_ORG_ROLE_SUCCESS: 'ORGANIZATION/UPDATE_ORG_ROLE_SUCCESS',
  UPDATE_ORG_ROLE_FAILURE: 'ORGANIZATION/UPDATE_ORG_ROLE_FAILURE'
}
